import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import TextTransition, { presets } from 'react-text-transition';

import Container from '@common/Container';
import Section from '@common/Section';
import RichText from '@common/RichText';
import Heading from '@common/Heading';

import Video from '@common/blocks/flex/Video';
import Buttons from '@common/blocks/flex/Buttons';
import Images from '@common/blocks/flex/Images';
import Links from '@common/blocks/flex/Links';
import MobileLinks from '@common/blocks/flex/MobileLinks';

import StarTopLeft from '@images/academy/star_top_left.svg';
import StarTopRight from '@images/academy/star_top_right.svg';
import StarBottomLeft from '@images/academy/star_bottom_left.svg';
import StarBottomRight from '@images/academy/star_bottom_right.svg';

import * as styles from '@common/blocks/flex/flex.module.scss';

const RotatingText = ({ data }) => {
  const {
    title,
    showBorder,
    text,
    textAlignment,
    textColWidth,
    tags,
    imagePosition,
    imagePositionTop,
    imagePositionTopLg,
    imageNegativeMargin,
    buttons,
    images,
    links,
    video,
    topMargin,
    bottomMargin,
    bgColour
  } = data;
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const intervalId = setInterval(() =>
      setIndex(index => index + 1),
      3000 // every 3 seconds
    );
    return () => clearTimeout(intervalId);
  }, []);
  return (
    <Section style={{ marginTop: `calc(${imageNegativeMargin} + 50px)` }} spacing={clsx(topMargin, bottomMargin ? bottomMargin : 'mb-7')} className={clsx({
        [styles.removeTopMargin]: imageNegativeMargin && !imagePositionTop
      })}>
      <Container>
        {video &&
          <Video data={data}/>
        }
        <div className={clsx(`d-flex flex-column align-items-center g-3`, {
            'flex-md-row-reverse': imagePosition === 'Left' && !imagePositionTopLg,
            'flex-md-row': imagePosition === 'Right' && !imagePositionTopLg,
            'flex-column-reverse': imagePositionTop || imagePositionTopLg,
            'justify-content-center': (!images || !links) && textAlignment === 'Center',
            'border border-dark-grey-4 border-3 rounded-3 px-3 py-3 py-lg-5': showBorder
          })}>
          {(text || buttons) &&
            <div className={clsx('col', textColWidth, {
                'text-center': textAlignment === 'Center',
                'text-end': textAlignment === 'Right',
                'text-start': textAlignment === 'Left',
              })}>
              <Heading type='h2' className='position-relative p-3'>
                {title}{' '}
                <TextTransition springConfig={presets.gentle} inline className={clsx({[`text-${bgColour}`]: bgColour})}>
                  {tags[index % tags.length]}
                </TextTransition>
                <img src={StarTopLeft} height='38.181' width='45.51' alt='' style={{position: 'absolute', top: -10, left: -10}}/>
                <img src={StarTopRight} height='42.756' width='44.178' alt='' style={{position: 'absolute', top: -10, right: -10}}/>
                <img src={StarBottomLeft} height='46.047' width='41.499' alt='' style={{position: 'absolute', bottom: -10, left: -10}}/>
                <img src={StarBottomRight} height='59.484' width='60.324' alt='' style={{position: 'absolute', bottom: -10, right: -10}}/>
              </Heading>
              {buttons && 
                <Buttons data={data} />
              }
            </div>
          }
          {images &&
            <Images data={data} />
          }
          {links &&
            <Links data={data} />
          }
        </div>
        {links &&
          <MobileLinks data={data} />
        }
      </Container>
    </Section>
  )
}

export default RotatingText
